<template>
  <div class="feedback-container">
    <div class="feedback-title">😊 期待您的反馈</div>
    <div class="quick-tag">
      <yxt-tag class="tag-item" v-for="(item, index) in feedbackQuickTag" :key="index" type="pick" pick-type="mark" :picked="selectedTag.includes(item)" @click="selectQuickTag(item)">
        {{ item }}
      </yxt-tag>
    </div>
    <yxtf-input
      type="textarea"
      class="feedback-input"
      show-word-limit
      :rows="3"
      :maxlength="200"
      placeholder="请输入反馈内容"
      v-model="feedbackContent">
    </yxtf-input>
    <div class="option">
      <yxtf-button round size="medium" @click="onCancel">取 消</yxtf-button>
      <yxtf-button type="primary" size="medium" round :disabled="!feedbackContent.trim()" @click="onSubmit" :loading="loading">提 交</yxtf-button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'FeedbackBox',
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      feedbackQuickTag: ['答非所问', '答案太长', '描述复杂看不懂', '描述错误'],
      selectedTag: [],
      feedbackContent: ''
    };
  },
  methods: {
    selectQuickTag(item) {
      const i = this.selectedTag.indexOf(item);
      i === -1 ? this.selectedTag.push(item) : this.selectedTag.splice(i, 1);
    },
    reset() {
      this.selectedTag = [];
      this.feedbackContent = '';
    },
    onCancel() {
      this.$emit('cancel');
    },
    onSubmit() {
      this.$emit('submit', this.selectedTag, this.feedbackContent);
    }
  }
};
</script>
<style lang="scss" scoped>
.feedback-container {
  width: 426px;
  padding: 20px 24px;
  background-color: #fff;
  border-radius: 12px;
  box-shadow: 0px 4px 24px 0px rgba(41,49,54,0.12);
  .feedback-title {
    font-size: 16px;
    font-weight: 500;
  }
  .quick-tag {
    margin-top: 16px;
    .tag-item:not(:last-child) {
      margin-right: 10px;
    }
  }
  .feedback-input {
    margin-top: 12px;
    ::v-deep textarea {
      border-radius: 8px;
    }
  }
  .option {
    margin-top: 16px;
    display: flex;
    justify-content: flex-end;
  }
}
</style>
